import { useCallback, useMemo, useState } from "react";
import { useToast } from "../../../Hooks/ToasContext";
import { IArtEntity } from "../../../Services/api/arts/arts.interface";
import { DestroyArtsUseCase } from "../../../Usecase/Arts/destroy-arts-usecase";
import { ListArtsUseCase } from "../../../Usecase/Arts/list-arts-usecase";

interface IUseListArtsProps {
  listArtsUseCase: ListArtsUseCase
  destroyArtsUseCase: DestroyArtsUseCase
}

export function useListArts({ listArtsUseCase, destroyArtsUseCase }: IUseListArtsProps){
    const [loading, setLoading] = useState(true)
    const [loadError, setLoadError] = useState(false)
    const [page, setPage] = useState(1)
    const [data, setData] = useState<IArtEntity[]>([])
    const [artToDestroy, setArtToDestroy] = useState('')
    const [totalRegisters, setTotalRegisters] = useState(1)
   
    const { showToast } =  useToast()

    const listArts = useCallback(async ({ page: currentPage }: { page: number }) => {
        try {
          setLoading(true)
          setLoadError(false)
          
          const listResult = await listArtsUseCase.handle(currentPage);

          if (listResult.isFailure) {
            setLoadError(true)
            showToast(String(listResult?.error?.error), 'error');
            return;
          }

         const list = listResult.getValue()

         setData(list?.data || [])
         setTotalRegisters(list?.data?.length || 0)
         setLoadError(false)
         setPage(currentPage)
        } catch (error) {
          setLoadError(true)
          console.error("error listArts function: ", error)
        } finally {
          setLoading(false);
        }
      }, [listArtsUseCase, showToast]);

    const list = useMemo(() => {
        const rows = data?.map(product => {

            return {
                id: product.id,
                code: product.artLink,
                size: product.customerId
            }
        })

        return rows
    }, [data])

    const handleDestroyArt = async () => {
        
      try {
        setLoading(true)
        
        const destroyResult = await destroyArtsUseCase.handle(artToDestroy);

        if (destroyResult.isFailure) {
     
          showToast(String(destroyResult?.error?.error), 'error');
          return;
        }

        setArtToDestroy('')
        showToast('Removido com sucesso.', 'success');

       await listArts({ page: 1 })
      } catch (error) {
        console.error("error destroyArts function: ", error)
      } finally {
        setLoading(false);
      }
    };

    return {
        loading,
        loadError,
        listArts,
        list,
        data,
        setArtToDestroy,
        artToDestroy,
        handleDestroyArt,
        totalRegisters
        
    }
}
